function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "calculator-01",
  transform: "translate(-0.15 0.05)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3371",
  "data-name": "Group 3371",
  transform: "translate(3.712 2.353)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3361",
  "data-name": "Group 3361",
  transform: "translate(-0.834 7.783)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3516",
  "data-name": "Path 3516",
  d: "M5.481,10.175H3.328A.927.927,0,0,1,2.5,9.181V7.028A.782.782,0,0,1,3.328,6.2H5.481a.782.782,0,0,1,.828.828V9.181A.829.829,0,0,1,5.481,10.175ZM3.328,6.7A.356.356,0,0,0,3,7.028V9.181a.356.356,0,0,0,.331.331H5.481a.356.356,0,0,0,.331-.331V7.028A.356.356,0,0,0,5.481,6.7Z",
  transform: "translate(-2.5 -6.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3362",
  "data-name": "Group 3362",
  transform: "translate(4.471 7.783)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3517",
  "data-name": "Path 3517",
  d: "M8.246,10.175H6.094A1.069,1.069,0,0,1,5.1,9.181V7.028A.782.782,0,0,1,5.928,6.2H8.246a.782.782,0,0,1,.828.828V9.181A.927.927,0,0,1,8.246,10.175ZM6.094,6.7a.356.356,0,0,0-.331.331V9.181a.356.356,0,0,0,.331.331H8.246a.356.356,0,0,0,.331-.331V7.028A.356.356,0,0,0,8.246,6.7Z",
  transform: "translate(-5.1 -6.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3363",
  "data-name": "Group 3363",
  transform: "translate(9.943 7.783)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3518",
  "data-name": "Path 3518",
  d: "M10.946,10.175H8.628A.927.927,0,0,1,7.8,9.181V7.028A.782.782,0,0,1,8.628,6.2h2.153a.782.782,0,0,1,.828.828V9.181A.73.73,0,0,1,10.946,10.175ZM8.628,6.7a.356.356,0,0,0-.331.331V9.181a.356.356,0,0,0,.331.331h2.153a.356.356,0,0,0,.331-.331V7.028a.356.356,0,0,0-.331-.331Z",
  transform: "translate(-7.8 -6.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3364",
  "data-name": "Group 3364",
  transform: "translate(-0.834 12.752)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3519",
  "data-name": "Path 3519",
  d: "M5.481,13.175H3.328a.782.782,0,0,1-.828-.828V10.028A.782.782,0,0,1,3.328,9.2H5.481a.782.782,0,0,1,.828.828v2.153A.829.829,0,0,1,5.481,13.175ZM3.328,9.7A.356.356,0,0,0,3,10.028v2.153a.356.356,0,0,0,.331.331H5.481a.356.356,0,0,0,.331-.331V10.028A.356.356,0,0,0,5.481,9.7Z",
  transform: "translate(-2.5 -9.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3365",
  "data-name": "Group 3365",
  transform: "translate(4.637 12.752)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3520",
  "data-name": "Path 3520",
  d: "M8.181,13.175H6.028a.782.782,0,0,1-.828-.828V10.028A.782.782,0,0,1,6.028,9.2H8.181a.782.782,0,0,1,.828.828v2.153A.927.927,0,0,1,8.181,13.175ZM6.028,9.7a.356.356,0,0,0-.331.331v2.153a.356.356,0,0,0,.331.331H8.181a.356.356,0,0,0,.331-.331V10.028A.356.356,0,0,0,8.181,9.7Z",
  transform: "translate(-5.2 -9.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3366",
  "data-name": "Group 3366",
  transform: "translate(9.943 12.752)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3521",
  "data-name": "Path 3521",
  d: "M10.946,13.175H8.628a.782.782,0,0,1-.828-.828V10.028A.782.782,0,0,1,8.628,9.2h2.153a.782.782,0,0,1,.828.828v2.153A.73.73,0,0,1,10.946,13.175ZM8.628,9.7a.356.356,0,0,0-.331.331v2.153a.356.356,0,0,0,.331.331h2.153a.356.356,0,0,0,.331-.331V10.028a.356.356,0,0,0-.331-.331Z",
  transform: "translate(-7.8 -9.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3367",
  "data-name": "Group 3367",
  transform: "translate(-0.834 17.885)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3522",
  "data-name": "Path 3522",
  d: "M5.481,16.109H3.328a.782.782,0,0,1-.828-.828V13.128a.782.782,0,0,1,.828-.828H5.481a.782.782,0,0,1,.828.828v1.987A.829.829,0,0,1,5.481,16.109ZM3.328,12.631A.356.356,0,0,0,3,12.962v2.153a.356.356,0,0,0,.331.331H5.481a.356.356,0,0,0,.331-.331V12.962a.356.356,0,0,0-.331-.331Z",
  transform: "translate(-2.5 -12.3)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3368",
  "data-name": "Group 3368",
  transform: "translate(4.637 17.885)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3523",
  "data-name": "Path 3523",
  d: "M8.181,16.109H6.028a.782.782,0,0,1-.828-.828V13.128a.782.782,0,0,1,.828-.828H8.181a.782.782,0,0,1,.828.828v1.987A.927.927,0,0,1,8.181,16.109ZM6.028,12.631a.356.356,0,0,0-.331.331v2.153a.356.356,0,0,0,.331.331H8.181a.356.356,0,0,0,.331-.331V12.962a.356.356,0,0,0-.331-.331Z",
  transform: "translate(-5.2 -12.3)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3369",
  "data-name": "Group 3369",
  transform: "translate(9.943 17.885)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3524",
  "data-name": "Path 3524",
  d: "M10.946,16.109H8.628a.782.782,0,0,1-.828-.828V13.128a.782.782,0,0,1,.828-.828h2.153a.782.782,0,0,1,.828.828v1.987A.73.73,0,0,1,10.946,16.109ZM8.628,12.631a.356.356,0,0,0-.331.331v2.153a.356.356,0,0,0,.331.331h2.153a.356.356,0,0,0,.331-.331V12.962a.356.356,0,0,0-.331-.331Z",
  transform: "translate(-7.8 -12.3)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3370",
  "data-name": "Group 3370"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3525",
  "data-name": "Path 3525",
  d: "M13.992,7.462H3.725A1.306,1.306,0,0,1,2.4,6.137V2.825A1.306,1.306,0,0,1,3.725,1.5H14.158a1.306,1.306,0,0,1,1.325,1.325V6.137A1.592,1.592,0,0,1,13.992,7.462ZM3.725,2a.782.782,0,0,0-.828.828V6.137a.782.782,0,0,0,.828.828H14.158a.782.782,0,0,0,.828-.828V2.825A.782.782,0,0,0,14.158,2Z",
  transform: "translate(-2.4 -1.5)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_3372",
  "data-name": "Group 3372",
  transform: "translate(0.4 0.2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3526",
  "data-name": "Path 3526",
  d: "M17.789,26.2H2.553A2.192,2.192,0,0,1,.4,24.047V2.353A2.192,2.192,0,0,1,2.553.2h15.07a2.192,2.192,0,0,1,2.153,2.153V24.047A1.956,1.956,0,0,1,17.789,26.2ZM2.553.7A1.66,1.66,0,0,0,.9,2.353V24.047A1.66,1.66,0,0,0,2.553,25.7h15.07a1.66,1.66,0,0,0,1.656-1.656V2.353A1.66,1.66,0,0,0,17.623.7Z",
  transform: "translate(-0.4 -0.2)",
  fill: "#fff",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
})));

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.896,
    height: 26.5,
    viewBox: "0 0 19.896 26.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.ff4ceee3.svg";
export { ForwardRef as ReactComponent };